import React, { useCallback } from 'react'

import { useRouter } from 'next/navigation'

import { PaddingProps } from 'styled-system'

import { SectionContainer } from 'Components/Blocks'
import { EventItem } from 'Types/emajinAPI'

import { GOOGLE_MAP_URL } from 'Constants/Ids'
import { LANDING_CONTENT_PX } from 'Constants/Landing'
import { EVENT_RSVP } from 'Constants/Paths'

import { useResponsiveLayout } from 'Hooks'

import EventBody from './EventBody'
import { Card, Container } from './styles'
import Titles from './Titles'

type Props = PaddingProps & {
  data?: EventItem
}

function EventDetailsDescriptionSection({ data, ...rest }: Props) {
  const { isDesktop } = useResponsiveLayout()
  const router = useRouter()

  const handleRSVP = useCallback(() => {
    if (!data) return

    sessionStorage.setItem('event', JSON.stringify(data))
    router.push(EVENT_RSVP(data.id))
  }, [data, router])

  const handleLocationClick = useCallback(() => {
    if (!data || !data.coordinate) return

    window.open(
      `${GOOGLE_MAP_URL}${data.coordinate.lat},${data.coordinate.lng}`,
      '_blank',
    )
  }, [data])

  if (!data) return null

  return (
    <SectionContainer {...rest} px={LANDING_CONTENT_PX}>
      <Container
        flexDirection={['column', 'column', 'column', 'column', 'row']}
      >
        <Card sticky={isDesktop} width={[1, 1, 1, 1, 2 / 5]}>
          <Titles data={data} onOpenLocation={handleLocationClick} />
        </Card>

        <Card width={[1, 1, 1, 1, 3 / 5]}>
          <EventBody data={data} onRSVP={handleRSVP} />
        </Card>
      </Container>
    </SectionContainer>
  )
}

export default EventDetailsDescriptionSection
